/* eslint-disable react/prop-types */
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import React, { useContext, useEffect, useState } from 'react'
import { Col, Row, FormGroup, Input, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import { isNotNumericDecimal } from 'context/Utilities'
import { packagingInitialState } from './constants'
import NutSeedButtersProduct from 'models/NutSeedButtersProduct'

const NutSeedButtersNutrition = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const methods = useFormContext()
  const { onChange, asterisk } = useFormUtils()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const { category, subCategory, Iron, Protein } = current

      setPackaging({
        category,
        subCategory,
        Iron,
        Protein,
      })
    } else if (!updating) {
      setCurrent(NutSeedButtersProduct)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Iron (mg) per 2 tablespoons (32g) {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="Iron"
            control={methods.control}
            rules={{
              required: '⚠ Please enter Iron (mg) per 2 tablespoons (32g)',
              maxLength: {
                value: 6,
                message:
                  '⚠ Iron (mg) per 2 tablespoons (32g) exceeds 6 characters',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onKeyDown={e => isNotNumericDecimal(e.key) && e.preventDefault()}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <ErrorMessage
            errors={methods.errors}
            name="Iron"
            as={<Alert color="danger" className="mt-3" />}
          />
        </FormGroup>
      </Col>

      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Protein (g) per 2 tablespoons (32g) {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="Protein"
            control={methods.control}
            rules={{
              required: '⚠ Please enter Protein (g) per 2 tablespoons (32g)',
              maxLength: {
                value: 4,
                message:
                  '⚠ Protein (g) per 2 tablespoons (32g) exceeds 4 characters',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onKeyDown={e => isNotNumericDecimal(e.key) && e.preventDefault()}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <ErrorMessage
            errors={methods.errors}
            name="Protein"
            as={<Alert color="danger" className="mt-3" />}
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default NutSeedButtersNutrition
